export interface Category {
  name: string;
  slug: string;
  url: string;
  itemCount: number;
  iconClass: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    itemCount: 2340,
    iconClass: 'ri-footprint-line',
  },
  {
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    itemCount: 1850,
    iconClass: 'ri-t-shirt-line',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    itemCount: 3210,
    iconClass: 'ri-shirt-line',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    itemCount: 1560,
    iconClass: 'ri-t-shirt-2-line',
  },
  {
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    itemCount: 1980,
    iconClass: 'ri-user-line',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    itemCount: 890,
    iconClass: 'ri-vip-crown-line',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    itemCount: 670,
    iconClass: 'ri-stack-line',
  },
  {
    name: 'Underwear/Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    itemCount: 1120,
    iconClass: 'ri-heart-line',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    itemCount: 1430,
    iconClass: 'ri-medal-line',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    itemCount: 2760,
    iconClass: 'ri-star-line',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    itemCount: 1640,
    iconClass: 'ri-briefcase-line',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    itemCount: 540,
    iconClass: 'ri-link',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    itemCount: 380,
    iconClass: 'ri-flask-line',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    itemCount: 2150,
    iconClass: 'ri-more-line',
  },
];